(function() {
  // P1 (2026-08-05) — Émetteur UNIQUE du bus panier, partagé par cart-unified / cart-drawer /
  // mk-gift. `detail.cart` = objet /cart.js COMPLET (items[].properties inclus). Idempotent :
  // défini une seule fois, réutilisé par les autres modules via window.mkEmitCartChanged.
  // Idempotent : le PREMIER des 3 modules chargés (mk-gift/cart-drawer/cart-unified) le définit ;
  // on appelle TOUJOURS via window.mkEmitCartChanged (late-bound) → aucune dépendance à l'ordre de
  // chargement ni au scope (cart-unified n'est chargé QUE sur les PDP ; le drawer est global).
  window.mkEmitCartChanged = window.mkEmitCartChanged || function (cart, source) {
    try {
      document.dispatchEvent(new CustomEvent('mk:cart:changed', { bubbles: true, detail: { cart: cart, source: source || '' } }));
    } catch (e) { /* noop */ }
  };

  function initUnifiedCart() {
    // Résout le VRAI formulaire d'achat de façon robuste (plusieurs form[action*="/cart/add"]
    // coexistent : Shop Pay "payment-installment", quick-buy des produits complémentaires, etc.).
    // Après un swap couleur AJAX l'ordre DOM peut changer → on ne peut pas se fier au 1er match.
    // Priorité : id "product-form-main-…" NON installment, contenant un input variant.
    function resolveMainForm() {
      var forms = document.querySelectorAll('form[action*="/cart/add"][id^="product-form-main"]:not([id*="installment"])');
      for (var i = 0; i < forms.length; i++) {
        if (forms[i].querySelector('input[name="id"]')) return forms[i];
      }
      var all = document.querySelectorAll('form[action*="/cart/add"]:not([id*="installment"])');
      for (var j = 0; j < all.length; j++) {
        if (all[j].querySelector('input[name="id"]')) return all[j];
      }
      return document.querySelector('form[action*="/cart/add"]');
    }

    function getSavedVehicle() {
      try {
        const saved = localStorage.getItem('matrikar_vehicle');
        return saved ? JSON.parse(saved) : null;
      } catch { return null; }
    }

    function isVehicleConfirmed() {
      const v = getSavedVehicle();
      return !!(v && v.make && v.year && v.model);
    }

    function ensureVehicleProperties(form) {
      if (!form) return false;
      // MK_NO_FIT 2026-09-30 : formulaire sans les 6 inputs vehicule rendus par le serveur
      // (produit tague no-vehicle-fit, ex. carte-cadeau) -> on n'y ajoute AUCUNE propriete vehicule.
      if (!form.querySelector('[data-mkvfit]')) return false;
      const vehicle = getSavedVehicle();
      if (!vehicle) return false;

      const props = [
        { key: 'vehicle', name: 'Vehicle', value: `${vehicle.make || ''} ${vehicle.model || ''} ${vehicle.sub || ''}`.trim() },
        { key: 'year',    name: 'Vehicle Year', value: vehicle.year || '' },
        { key: 'trim',    name: 'Trim', value: vehicle.sub || '' },
        { key: 'seats',   name: 'Seats', value: vehicle.seats ? `${vehicle.seats} seats` : '' },
        { key: 'drive',   name: 'Drive Side', value: vehicle.drive || '' },
        { key: 'fuel',    name: 'Fuel Type', value: vehicle.fuel || '' }
      ];

      for (const prop of props) {
        if (!prop.value) continue;
        let input = form.querySelector(`[data-mkvfit="${prop.key}"]`);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = `properties[${prop.name}]`;
          input.setAttribute('data-mkvfit', prop.key);
          form.appendChild(input);
        }
        input.value = prop.value;
        // MK GARDE SERVEUR (2026-07-16) — CRITIQUE : les 6 inputs sont desormais rendus par le
        // serveur avec `disabled` (buy-buttons.liquid) pour qu'aucune propriete VIDE ne parte.
        // On REACTIVE donc l'input des qu'on lui donne une vraie valeur : sans ca, FormData
        // l'ignorerait et la propriete serait PERDUE sur ce chemin.
        input.disabled = false;
      }
      return true;
    }

    // Les libellés arrivent du pont i18n de theme.liquid via `{{ '…' | t | json }}`. Le filtre
    // `| t` de Shopify ÉCHAPPE le HTML : la locale EN contient un `&` propre
    // ("Please select & confirm your vehicle first") mais la chaîne livrée au JS contient
    // "&amp;". Comme on l'écrit avec textContent (qui ne décode pas les entités), le client
    // lisait littéralement "&amp;". On décode donc avant affichage.
    // Le <textarea> détaché est le décodage sûr : son modèle de contenu est du TEXTE pur, donc
    // innerHTML n'y crée ni élément ni script (pas de vecteur XSS), contrairement à un <div>.
    function decodeEntities(str) {
      if (typeof str !== 'string' || str.indexOf('&') === -1) return str;
      const ta = document.createElement('textarea');
      ta.innerHTML = str;
      return ta.value;
    }

    function showMessage(msg, isError = false) {
      msg = decodeEntities(msg);
      let toast = document.getElementById('bundle-toast');
      if (!toast) {
        toast = document.createElement('div');
        toast.id = 'bundle-toast';
        Object.assign(toast.style, {
          position: 'fixed', bottom: '28px', left: '50%',
          transform: 'translateX(-50%) translateY(16px)',
          background: isError ? '#D71A23' : '#030213',
          color: '#fff', fontSize: '14px', fontWeight: '600',
          padding: '12px 24px', borderRadius: '4px',
          opacity: '0', transition: 'opacity .3s, transform .3s',
          zIndex: '99999', pointerEvents: 'none',
          fontFamily: 'inherit'
        });
        document.body.appendChild(toast);
      }
      toast.textContent = msg;
      toast.style.background = isError ? '#D71A23' : '#030213';
      toast.style.opacity = '1';
      toast.style.transform = 'translateX(-50%) translateY(0)';
      clearTimeout(toast._timer);
      toast._timer = setTimeout(() => {
        toast.style.opacity = '0';
        toast.style.transform = 'translateX(-50%) translateY(16px)';
      }, 3000);
    }

    async function addItemToCart(variantId, sourceForm = null) {
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);

      if (sourceForm) {
        for (let [key, value] of new FormData(sourceForm)) {
          if (key.startsWith('properties[')) {
            formData.append(key, value);
          }
        }
        ensureVehicleProperties(sourceForm);
        for (let [key, value] of new FormData(sourceForm)) {
          if (key.startsWith('properties[') && !formData.has(key)) {
            formData.append(key, value);
          }
        }
      }

      const response = await fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      });
      if (!response.ok) throw new Error(`Failed to add variant ${variantId}`);
      return response.json();
    }

    // ═══ MK_PERSONALIZATION 2026-08-30 ═══
    // Ajoute la ligne add-on qui FACTURE le supplément de finition (logo Matrikar, logo/texte
    // personnalisé, poche latérale). Le CHOIX lui-même voyage en line item property sur la ligne
    // du tapis (posée par le formulaire) ; cette ligne-ci ne porte que le prix.
    //
    // AUTORITÉ DE PRIX = les variantes du produit `mat-personalization` (UNLISTED). On envoie un
    // variant ID, jamais un montant.
    //
    // On n'appelle PAS addItemToCart() : il recopierait toutes les properties du formulaire tapis
    // (véhicule, Personalization…) sur l'add-on, qui n'en a besoin d'aucune. Le marqueur
    // `_mk_perso_addon` sert au drawer pour rendre cette ligne EN SOUS-LIGNE du tapis.
    async function addPersonalizationAddon(selection) {
      const formData = new FormData();
      formData.append('id', selection.variantId);
      formData.append('quantity', 1);
      formData.append('properties[_mk_perso_addon]', selection.code);
      if (selection.label) formData.append('properties[_mk_perso_label]', selection.label);
      // Rattachement au tapis : le drawer s'en sert pour ranger la sous-ligne DERRIÈRE le bon
      // article (l'ordre de /cart.js n'est pas fiable, cf. orderPersoAddons dans cart-drawer.js).
      if (selection.matVariantId) formData.append('properties[_mk_perso_for]', selection.matVariantId);
      // Vignette de la finition : le produit add-on n'a aucune image, et de toute façon il faut
      // celle de la GAMME choisie (le motif diffère entre Diamond, Hexa, Ribbed et Dual-Layer).
      if (selection.image) formData.append('properties[_mk_perso_img]', selection.image);

      const response = await fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      });
      if (!response.ok) throw new Error(`Failed to add personalization add-on ${selection.variantId}`);
      return response.json();
    }

    function currentPersonalization() {
      if (typeof window.mkPersoSelection !== 'function') return null;
      try {
        const sel = window.mkPersoSelection();
        return (sel && sel.variantId) ? sel : null;
      } catch (e) { return null; }
    }

    // MK_GIFT (2026-09-22) — le cadeau chargeur est MANUEL : il ne part que si le client a
    // coche le bouton du bloc cadeau (snippets/mk-gift-promo.liquid). On lit son choix ici,
    // jamais un prix : l'autorite de prix, c'est la variante du produit cache
    // `gift-wireless-car-charger` ramenee a 0 par la remise automatique.
    function currentGiftChoice() {
      if (typeof window.mkGiftSelection !== 'function') return null;
      try {
        const sel = window.mkGiftSelection();
        return (sel && sel.selected && sel.variantId) ? sel : null;
      } catch (e) { return null; }
    }

    // Ligne cadeau ajoutee JUSTE APRES le tapis, comme l'add-on personnalisation, pour que les
    // deux lignes se suivent dans le panier. Le marqueur `_free_gift` sert a l'identification
    // (badge INCLUDED, menage par assets/mk-gift.js) et JAMAIS a fixer un prix.
    // On n'appelle PAS addItemToCart() : il recopierait les properties du formulaire tapis
    // (vehicule, Personalization) sur une ligne qui n'en a besoin d'aucune.
    async function addGiftLine(selection) {
      const formData = new FormData();
      formData.append('id', selection.variantId);
      formData.append('quantity', 1);
      formData.append('properties[_free_gift]', selection.marker || 'wireless-charger');

      const response = await fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      });
      if (!response.ok) throw new Error(`Failed to add gift ${selection.variantId}`);
      return response.json();
    }

    async function refreshCartCount() {
      const res = await fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart.js');
      const cart = await res.json();
      const count = cart.item_count;
      document.querySelectorAll('.cart-count, .cart__count, .cart-item-count, [data-cart-count], .header__cart-count, .cart-count-bubble')
        .forEach(el => { if (el) el.textContent = count; });
      // P1-opt (2026-08-05) — `cart:refresh` RETIRÉ : il déclenchait un GET /cart.js REDONDANT du
      // compteur natif Prestige (theme.js). Le compteur est déjà mis à jour ci-dessus (sélecteurs
      // directs) ET par le bus (renderTotals → #mkCartCount). Une requête de moins par ajout.
      // P1 (2026-08-05) — BUS PANIER UNIFIÉ : une seule source de vérité après l'ajout.
      // On émet le panier COMPLET (avec properties de ligne) ; le drawer, le compteur et le
      // reconciler cadeau ÉCOUTENT `mk:cart:changed` au lieu de patcher window.fetch chacun de
      // leur côté (fin de la cascade de 8 GET /cart.js). detail.cart porte les properties → la
      // ligne cadeau (_free_gift) et les props véhicule du tapis s'affichent sans refetch.
      window.mkEmitCartChanged(cart, 'unified-add');
    }

    function openCartDrawer() {
      // Open the drawer directly (locale-agnostic, never navigates). Previously this clicked
      // an a[href="/cart"]; in FR that resolved to the in-drawer "View full cart" link, whose
      // handler closed the drawer and navigated to /cart. openMatrikarCart === openDrawer.
      if (typeof window.openMatrikarCart === 'function') { window.openMatrikarCart(); return; }
      const cartIcon = document.querySelector('.mk-cart-link, [aria-controls="cart-drawer"], [data-cart-drawer-toggle]');
      if (cartIcon) { cartIcon.click(); return; }
      document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    }

    async function addMainAndBundleToCart(event, opts) {
      if (event) event.preventDefault();
      const toCheckout = !!(opts && opts.toCheckout);

      const mainForm = resolveMainForm();
      if (!mainForm) {
        showMessage((window.MK_I18N && window.MK_I18N.cu_form_not_found) || 'Main product form not found', true);
        return false;
      }

      // MK_NO_FIT 2026-09-30 : le vehicule n'est exige que si le serveur a rendu les inputs
      // vehicule dans le formulaire (buy-buttons.liquid, absents sur les produits no-vehicle-fit).
      const needsVehicle = !!mainForm.querySelector('[data-mkvfit]');
      if (needsVehicle && !isVehicleConfirmed()) {
        showMessage((window.MK_I18N && window.MK_I18N.cu_confirm_vehicle_first) || 'Please select & confirm your vehicle first', true);
        return false;
      }
      // Sans vehicule, le clic est intercepte avant la validation native : on la rejoue
      // (courriel du destinataire obligatoire quand la case « envoyer en cadeau » est cochee).
      if (!needsVehicle && typeof mainForm.reportValidity === 'function' && !mainForm.reportValidity()) {
        return false;
      }

      const variantInput = mainForm.querySelector('input[name="id"]');
      let mainVariantId = variantInput ? variantInput.value : null;
      if (!mainVariantId) {
        const selectedOption = mainForm.querySelector('select[name="id"] option:checked');
        if (selectedOption) mainVariantId = selectedOption.value;
      }
      if (!mainVariantId) {
        showMessage((window.MK_I18N && window.MK_I18N.cu_variant_error) || 'Could not determine main product variant', true);
        return false;
      }

      const bundleCheckboxes = document.querySelectorAll('#bundleProductsContainer .bundle-checkbox-input:checked');
      const bundleVariantIds = Array.from(bundleCheckboxes).map(cb => cb.dataset.variantId).filter(v => v);

      const allButtons = document.querySelectorAll('.bundle-add-btn, .mk-cta-btn, .mkv2-snav-btn, mkv3-snav-btn, .mkp-snav-btn, button[type="submit"][form*="product-form"]');
      allButtons.forEach(btn => { btn.disabled = true; btn.textContent = 'Adding...'; });

      try {
        await addItemToCart(parseInt(mainVariantId, 10), mainForm);
        // MK_PERSONALIZATION — le supplément suit IMMÉDIATEMENT le tapis, avant les bundles, pour
        // que les deux lignes se retrouvent côte à côte dans le panier (le drawer rattache ensuite
        // visuellement l'add-on au tapis qui le précède).
        const persoSelection = currentPersonalization();
        if (persoSelection) {
          persoSelection.matVariantId = parseInt(mainVariantId, 10);
          await addPersonalizationAddon(persoSelection);
        }
        // MK_GIFT (2026-09-22) — le cadeau suit le tapis et sa personnalisation. Enveloppe dans
        // son propre try : un cadeau qui echoue ne doit JAMAIS faire echouer l'ajout du tapis,
        // qui est deja dans le panier a ce stade. En cas d'echec on ne dit rien au client, le
        // reconciler (assets/mk-gift.js) ne re-ajoutera pas non plus : le cadeau est manuel.
        const giftSelection = currentGiftChoice();
        if (giftSelection) {
          try {
            await addGiftLine(giftSelection);
            if (typeof window.mkGiftConsume === 'function') window.mkGiftConsume();
          } catch (giftErr) {
            console.error(giftErr);
          }
        }
        // HOTFIX_BUNDLE_SYSTEM_V22 — propager vehicle properties (Vehicle, Year, Trim, Seats, Drive, Fuel)
        // sur chaque bundle item via mainForm comme sourceForm. ensureVehicleProperties() relit localStorage.
        for (const vid of bundleVariantIds) {
          await addItemToCart(parseInt(vid, 10), mainForm);
        }
        await refreshCartCount();
        const bundleCount = bundleVariantIds.length;
        // MK_EXPRESS (2026-09-27) : clic sur un bouton de paiement rapide avec un ajout (finition,
        // cadeau, tapis de coffre, housses) -> tout est dans le panier, on part au paiement au lieu d'ouvrir le tiroir.
        if (toCheckout) { window.location.href = '/checkout'; return true; }
        showMessage(bundleCount ? `Main product + ${bundleCount} bundle item(s) added!` : 'Product added to cart!');
        openCartDrawer();
        return true;
      } catch (err) {
        console.error(err);
        showMessage('Something went wrong. Please try again.', true);
        return false;
      } finally {
        allButtons.forEach(btn => {
          btn.disabled = false;
          if (btn.classList.contains('bundle-add-btn')) btn.textContent = 'Add Bundle to Cart';
          else if (btn.classList.contains('mk-cta-btn')) btn.textContent = btn.getAttribute('data-original-label') || 'CONFIGURE YOURS';
          else if (btn.classList.contains('mkv2-snav-btn')) btn.textContent = 'Add to cart';
          else if (btn.classList.contains('mkv3-snav-btn')) btn.textContent = 'Add to cart';
          else if (btn.classList.contains('mkp-snav-btn')) btn.textContent = 'Add to Cart';
          else if (btn.closest('form')) btn.textContent = 'Add to Cart';
        });
      }
    }

    // Déclencheur ATC principal par DÉLÉGATION sur document — survit aux re-render du swap couleur
    // (un bind sur le noeud bouton serait perdu à chaque innerHTML). Scopé à la section main-product,
    // exclut le formulaire Shop Pay "installment". preventDefault annule le submit → le <product-form>
    // natif ne se déclenche pas → un SEUL ajout, avec les propriétés véhicule. Posé une seule fois.
    if (!window.__mkuc_atc_delegated) {
      window.__mkuc_atc_delegated = true;
      document.addEventListener('click', function (e) {
        const btn = e.target && e.target.closest
          ? e.target.closest('.shopify-section--main-product form[action*="/cart/add"] button[type="submit"]')
          : null;
        if (!btn) return;
        const f = btn.closest('form[action*="/cart/add"]');
        if (!f || /installment/i.test(f.id || '')) return;
        e.preventDefault();
        addMainAndBundleToCart(e);
      });
    }

    // MK_EXPRESS (2026-09-27) — Les boutons de paiement rapide de la fiche (Shop Pay, Apple Pay,
    // « Plus de moyens de paiement ») envoient le formulaire tel quel : le tapis part SEUL, sans la
    // ligne payante de personnalisation, ni le chargeur offert, ni les produits cochés (tapis de
    // coffre, housses) : commande #1696. Quand l'un d'eux est choisi, on intercepte le clic AVANT le
    // bouton Shopify (phase de capture), on remplit le panier comme « Ajouter au panier », puis on
    // envoie au paiement. Sans aucun ajout, on ne
    // touche à rien : le paiement rapide natif reste identique.
    // Les boutons ADD du tapis de coffre et des housses mettent le produit DIRECTEMENT au panier
    // (pas de case cochée). Le paiement rapide de la fiche ignore le panier : on suit donc le nombre
    // d'articles, via le bus `mk:cart:changed` et une lecture au chargement.
    if (!window.__mkuc_express_delegated) {
      window.__mkuc_express_delegated = true;
      window.__mkuc_cart_count = 0;
      fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart.js').then(r => r.json()).then(c => { window.__mkuc_cart_count = c.item_count || 0; }).catch(() => {});
      document.addEventListener('mk:cart:changed', function (ev) {
        const c = ev && ev.detail && ev.detail.cart;
        if (c) window.__mkuc_cart_count = c.item_count || 0;
      });
      document.addEventListener('click', function (e) {
        const grid = e.target && e.target.closest
          ? e.target.closest('.shopify-section--main-product .express-payments-grid')
          : null;
        if (!grid) return;
        // Tout ce que la fiche ajoute en plus du tapis : finition payante, cadeau, et tout article déjà
        // au panier (tapis de coffre, housses ajoutés par ADD).
        const hasBundle = !!document.querySelector('#bundleProductsContainer .bundle-checkbox-input:checked');
        const cartHasItems = window.__mkuc_cart_count > 0;
        if (!currentPersonalization() && !currentGiftChoice() && !hasBundle && !cartHasItems) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        addMainAndBundleToCart(null, { toCheckout: true });
      }, true);
    }

    const bundleBtn = document.getElementById('addBundleBtn');
    if (bundleBtn && !bundleBtn.hasAttribute('data-mkuc-bound')) {
      const newBundleBtn = bundleBtn.cloneNode(true);
      newBundleBtn.setAttribute('data-mkuc-bound', '1');
      bundleBtn.parentNode.replaceChild(newBundleBtn, bundleBtn);
      newBundleBtn.addEventListener('click', addMainAndBundleToCart);
    }

    const ctaBtn = document.getElementById('mk-cta-atc-btn');
    if (ctaBtn && !ctaBtn.hasAttribute('data-mkuc-bound')) {
      const newCtaBtn = ctaBtn.cloneNode(true);
      newCtaBtn.setAttribute('data-mkuc-bound', '1');
      newCtaBtn.setAttribute('data-original-label', newCtaBtn.textContent);
      ctaBtn.parentNode.replaceChild(newCtaBtn, ctaBtn);
      newCtaBtn.addEventListener('click', addMainAndBundleToCart);
    }

    const stickyV2Btn = document.querySelector('.mkv2-snav-btn[data-snav-atc]');
    if (stickyV2Btn && !stickyV2Btn.hasAttribute('data-mkuc-bound')) {
      const newStickyV2 = stickyV2Btn.cloneNode(true);
      newStickyV2.setAttribute('data-mkuc-bound', '1');
      stickyV2Btn.parentNode.replaceChild(newStickyV2, stickyV2Btn);
      newStickyV2.addEventListener('click', addMainAndBundleToCart);
    }

    const stickyV3Btn = document.querySelector('.mkv3-snav-btn[data-snav-atc]');
    if (stickyV3Btn && !stickyV3Btn.hasAttribute('data-mkuc-bound')) {
      const newStickyV3 = stickyV3Btn.cloneNode(true);
      newStickyV3.setAttribute('data-mkuc-bound', '1');
      stickyV3Btn.parentNode.replaceChild(newStickyV3, stickyV3Btn);
      newStickyV3.addEventListener('click', addMainAndBundleToCart);
    }

    const mkpStickyBtn = document.querySelector('.mkp-snav-btn');
    if (mkpStickyBtn && !mkpStickyBtn.hasAttribute('data-mkuc-bound')) {
      const newMkpSticky = mkpStickyBtn.cloneNode(true);
      newMkpSticky.setAttribute('data-mkuc-bound', '1');
      mkpStickyBtn.parentNode.replaceChild(newMkpSticky, mkpStickyBtn);
      newMkpSticky.addEventListener('click', addMainAndBundleToCart);
    }

    document.querySelectorAll('form[action*="/cart/add"] button[type="submit"]').forEach(btn => {
      if (btn.closest('.shopify-section--main-product')) return; // ATC principal géré par le délégué
      if (btn.hasAttribute('data-mkuc-bound')) return;
      btn.setAttribute('data-mkuc-bound', '1');
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        addMainAndBundleToCart();
      });
    });
  }

  // #5a — exposé pour ré-hydrater le buy-flow après un swap couleur AJAX (bindings directs, pas délégués).
  // Idempotent : chaque élément est marqué data-mkuc-bound, donc un rappel ne double-bind jamais.
  window.mkReinitUnifiedCart = initUnifiedCart;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUnifiedCart);
  } else {
    initUnifiedCart();
  }
})();
